const getHeading = () => {
    const heading = document.querySelector('h1');
    return heading ? heading.innerText : '';
}

export const startIncome = () => {
    window.appEventData.push({
        event: 'Form Start',
        page: {
            pageInfo: {
                pageName: 'Income Protection Insurance Calculator | Suncorp',
                pageType: 'Step 0', //eg.: Step 0
                pageCategory: getHeading(), //eg.: Income Protection Insurance Calculator
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const startLife = () => {
    window.appEventData.push({
        event: 'Form Start',
        page: {
            pageInfo: {
                pageName: 'Life Insurance Calculator | Suncorp',
                pageType: 'Step 0', //eg.: Step 0
                pageCategory: getHeading(), //eg.: Income Protection Insurance Calculator
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const step = (step) => {
    window.appEventData.push({
        event: 'Form Step',
        page: {
            pageInfo: {
                pageName: document.title,
                pageType: `Step ${step}`, //eg.: Step 1
                pageCategory: getHeading(), //eg.: Income Protection Insurance Calculator
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const completeIncome = () => {
    window.appEventData.push({
        event: 'Form Confirmation',
        page: {
            pageInfo: {
                pageName: document.title,
                pageType: 'Results page', //eg.: Results Page
                pageCategory: getHeading(), //eg.: Estimate of income protection
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const completeLife = () => {
    window.appEventData.push({
        event: 'Form Confirmation',
        page: {
            pageInfo: {
                pageName: document.title,
                pageType: 'Results page', //eg.: Results Page
                pageCategory: getHeading(), //eg.: Income Protection Insurance Calculator
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const resetIncome = () => {
    window.appEventData.push({
        event: 'Calculator Reset',
        page: {
            pageInfo: {
                pageName: document.title,
                pageType: 'Results page', //eg.: Results Page
                pageCategory: getHeading(), //eg.: Estimate of income protection
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const resetLife = () => {
    window.appEventData.push({
        event: 'Calculator Reset',
        page: {
            pageInfo: {
                pageName: document.title,
                pageType: 'Results page', //eg.: Results Page
                pageCategory: getHeading(), //eg.: Income Protection Insurance Calculator
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};

export const linkClick = (linkText, url, step) => {
    window.appEventData.push({
        event: 'Link Click',
        link: {
            name: linkText.trim(),
            link: url,
            title: document.title
        },
        page: {
            pageInfo: {
                pageName: document.title,
                pageType: `Step ${step}`,
                pageCategory: getHeading(),
                brand: 'SUN', //eg.: AAMI
                environment: 'Production', //eg.: Production
                language: 'English', //eg.: English
                mcode: '' //eg.: TALC017
            }
        }
    });
};